module.exports = __webpack_public_path__ + "static/img/86-2.e340e8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/86-2.jpg
// module id = Idz2
// module chunks = 0